// extracted by mini-css-extract-plugin
export var changeFilter = "changeFilter__ZQpF";
export var heading = "heading__eqK6";
export var notFoundContainer = "not-found-container__qNYD";
export var text = "text__dVPp";